export const generateRandomNum = (): number => {
  return Math.floor((Math.random() * 10000));
};